<template>
  <ValidationProvider tag="div" :rules="rules" :name="name" :vid="vid" v-slot="{ errors, validate }" :mode="mode">
    <div ref="datepicker">
      <DatePicker
        v-model="currentValue"
        :input-class="[
          inputClass,
          {
            'is-invalid': errors.length,
          },
        ]"
        :format="format"
        :value-type="inputFormat"
        @close="validate"
        v-bind="$attrs"
        :editable="editable"
        :disabled="disabled"
      ></DatePicker>
    </div>
    <template v-if="errors">
      <b-tooltip
        v-if="errorMode == 'tooltip'"
        :target="() => $refs['datepicker']"
        :title="errors.length ? errors[0] : null"
        variant="danger"
        noninteractive
        placement="top"
        boundary="window"
      ></b-tooltip>
      <div v-else class="text-danger">
        {{ errors[0] }}
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
// format="DD-MM-YY" value-type="YYYY-MM-DD" :editable="false"
import { ValidationProvider } from "vee-validate";
import DatePicker from "vue2-datepicker";
import { BTooltip } from "bootstrap-vue";
export default {
  name: "InputDatepicker",
  components: {
    ValidationProvider,
    DatePicker,
    BTooltip,
  },
  props: {
    value: {
      type: [String, Object, Array],
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    mode: {
      type: String,
      default: "eager",
    },
    format: {
      type: String,
      default: "DD-MM-YY",
    },
    inputFormat: {
      type: String,
      default: "YYYY-MM-DD",
    },
    inputClass: {
      type: String,
      default: "form-control form-control-sm",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    errorMode: {
      type: String,
      default: "normal",
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    currentValue(val) {
      this.$emit("input", val);
    },
  },
};
</script>
